// extracted by mini-css-extract-plugin
export default {"root":"Features_root__az2Na","header":"Features_header__7I62W","grid":"Features_grid__jYeGO","inviteButton":"Features_inviteButton__s9MUf"};